/*=========================================================================================
  File Name: actions.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: 
  Author: Tan Tran
==========================================================================================*/
import authService from '../../../services/auth/auth.js'
import authStorage from '../../../storage/authStorage.js'

const actions = {
    async loginAction( { commit }, payload ) {
      return await authService.authenticate(payload)
                        .then( response => {
                                if (response.success)  {
                                  commit('SET_LOGIN_STATE', response);
                                  authStorage.storeAuth(response);
                                }
                                return response;    
                        });
    }
}

export default actions;